<template>
  <div class="e-dialog-content">
    <slot />
    <slot v-if="$slots.title || props.title" name="title">
      <div class="e-dialog-content__title">
        {{ props.title }}
      </div>
    </slot>
    <slot v-if="$slots.description || props.description" name="description">
      <div class="e-dialog-content__description">
        {{ props.description }}
      </div>
    </slot>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
})
</script>

<style lang="scss">
@import '../../scss/styles';
@import 'vuetify/lib/styles/settings/variables';
.e-dialog-content {
  overflow: auto;
  padding: 16px;
  &__title {
    text-align: center;
    @include headline-3;
  }
  &__description {
    margin-top: 4px;
    text-align: center;
  }
}

@media #{map-get($display-breakpoints, 'xs')} {
  .e-dialog-content {
    padding: 24px;
  }
}
</style>
